const Footer = () => {
    
    return (
        <footer className="footer">
            <div>
                Powered by{' '}
                <span className="logo">
                    <img src="/img/Cribis_ACrifCompany.gif" alt="Cribis Logo" width={84} height={32} />
                </span>
            </div>
        </footer>
    );
}

export default Footer